<button
  (click)="onClick($event)"
  [ngClass]="{ 'button-hover': !disable && buttonHover, disabled: disable,
    'btn-small': size === 'small'}"
  [ngStyle]="ngStyle">
  <ng-content></ng-content>
</button>
